// ─── Guest Review Types & Tag Definitions ────────────────────────────────────

export interface FeedbackTag {
  key: string;
  label: string;
  emoji: string;
}

export const POSITIVE_FEEDBACK_TAGS: FeedbackTag[] = [
  { key: 'great_food', label: 'Great Food', emoji: '🍽️' },
  { key: 'fast_service', label: 'Fast Service', emoji: '⚡' },
  { key: 'friendly_staff', label: 'Friendly Staff', emoji: '😊' },
  { key: 'clean_environment', label: 'Clean Environment', emoji: '✨' },
  { key: 'value_for_money', label: 'Value for Money', emoji: '💰' },
];

export const NEGATIVE_FEEDBACK_TAGS: FeedbackTag[] = [
  { key: 'slow_service', label: 'Slow Service', emoji: '🐢' },
  { key: 'food_quality', label: 'Food Quality', emoji: '🍴' },
  { key: 'portion_size', label: 'Portion Size', emoji: '📏' },
  { key: 'cleanliness', label: 'Cleanliness', emoji: '🧹' },
  { key: 'staff_attitude', label: 'Staff Attitude', emoji: '😕' },
  { key: 'too_expensive', label: 'Too Expensive', emoji: '💸' },
];

export interface GuestReview {
  id: string;
  restaurantId: string;
  orderId: string | null;
  guestId: string | null;
  sessionToken: string | null;
  rating: number;
  feedbackTags: string[];
  comment: string | null;
  orderType: string | null;
  createdAt: string;
}

export interface SubmitReviewParams {
  restaurantId: string;
  orderId?: string;
  sessionToken?: string;
  rating: number;
  feedbackTags: string[];
  comment?: string;
  orderType?: string;
}
